import { config } from "@app-contexts/sdk/services/config";
import {
  Widget,
  type WidgetLaunchOptions,
  WidgetQueryParams,
} from "@app-contexts/sdk/services/Widget";

import { prepareWidgetParams } from "./checkout";
import {
  getCustomerAttributionWidgetOptions,
  getEmbeddedWidgetOptions,
} from "./embedded-widget-options";

/**
 * Shows a membership purchase widget for the specified membership
 * @param id id of membership
 * @param params values to add to URL params (e.g. 'theme-primary', 'theme-secondary', etc.)
 * @param containerId id of the container to embed the widget in
 * @param options optional host callback used to refresh a rejected attribution token
 */
export async function membershipPurchaseWidget(
  id: string,
  params: WidgetQueryParams,
  containerId?: string,
  options: WidgetLaunchOptions = {}
) {
  const enrichedParams = prepareWidgetParams(params);

  const widget = new Widget({
    src: await config.membershipPurchaseWidgetUrl(id),
    containerId,
    queryParams: enrichedParams,
    ...getEmbeddedWidgetOptions(containerId),
    ...getCustomerAttributionWidgetOptions(enrichedParams, options),
  });

  widget.show();

  return widget;
}
